import {
	INCIDENTS,
	CHANGES,
} from '@atlassian/jira-servicedesk-work-category/src/common/constants.tsx';

export const EP_MESSAGES = {
	[CHANGES]: 'affected-assets-in-jsm-cm',
	[INCIDENTS]: 'affected-assets-in-jsm-im',
};
